import React from 'react';

var MobileLobbyWr = function (_a) {
    var children = _a.children, backgroundImage = _a.backgroundImage;
    return (React.createElement("div", { className: 'pgc-m-lobby', style: { backgroundImage: backgroundImage } }, children));
};

export { MobileLobbyWr };
